import * as yup from 'yup';

export const ResidentChecklistSchema = yup.object({
  roomKeyOutput: yup.boolean().notRequired().nullable(),
  roomKeyOutputDate: yup.date().notRequired().nullable(),
  keyNumber: yup.string().notRequired().nullable(),
  receivedHomeContractBack: yup.boolean().notRequired().nullable(),
  receivedHomeContractBackDate: yup.date().notRequired().nullable(),
  homeContractKZPOrVHPReceivedBack: yup.boolean().notRequired().nullable(),
  homeContractKZPOrVHPReceivedBackDate: yup.date().notRequired().nullable(),
  medicalCertificateReceivedBack: yup.boolean().notRequired().nullable(),
  medicalCertificateReceivedBackDate: yup.date().notRequired().nullable(),
  registrationFormReceivedBack: yup.boolean().notRequired().nullable(),
  registrationFormReceivedBackDate: yup.date().notRequired().nullable(),
  supervisorIdReceivedBack: yup.boolean().notRequired().nullable(),
  supervisorIdReceivedBackDate: yup.date().notRequired().nullable(),
  powerOfAttorneyReceivedBack: yup.boolean().notRequired().nullable(),
  powerOfAttorneyReceivedBackDate: yup.date().notRequired().nullable(),
  patientDecreeReceivedBack: yup.boolean().notRequired().nullable(),
  patientDecreeReceivedBackDate: yup.date().notRequired().nullable(),
  copyOfIdCardReceivedBack: yup.boolean().notRequired().nullable(),
  copyOfIdCardReceivedBackDate: yup.date().notRequired().nullable(),
  exemptionFromIDRequirements: yup.boolean().notRequired().nullable(),
  exemptionFromIDRequirementsDate: yup.date().notRequired().nullable(),
  careLevelNotificationReceivedBack: yup.boolean().notRequired().nullable(),
  careLevelNotificationReceivedBackDate: yup.date().notRequired().nullable(),
  disabilityCard: yup.boolean().notRequired().nullable(),
  disabilityCardDate: yup.date().notRequired().nullable(),
  marcurmarPassport: yup.boolean().notRequired().nullable(),
  marcurmarPassportDate: yup.date().notRequired().nullable(),
  implantationPassport: yup.boolean().notRequired().nullable(),
  implantationPassportDate: yup.date().notRequired().nullable(),
  pacemakerIDCard: yup.boolean().notRequired().nullable(),
  pacemakerIDCardDate: yup.date().notRequired().nullable(),
  roomKeyReturned: yup.boolean().notRequired().nullable(),
  roomKeyReturnedDate: yup.date().notRequired().nullable(),
});

export interface IResidentChecklist {
  roomKeyOutput: boolean;
  roomKeyOutputDate?: Date;
  keyNumber?: string;
  receivedHomeContractBack: boolean;
  receivedHomeContractBackDate?: Date;
  homeContractKZPOrVHPReceivedBack: boolean;
  homeContractKZPOrVHPReceivedBackDate?: Date;
  medicalCertificateReceivedBack: boolean;
  medicalCertificateReceivedBackDate?: Date;
  registrationFormReceivedBack: boolean;
  registrationFormReceivedBackDate?: Date;
  supervisorIdReceivedBack: boolean;
  supervisorIdReceivedBackDate?: Date;
  powerOfAttorneyReceivedBack: boolean;
  powerOfAttorneyReceivedBackDate?: Date;
  patientDecreeReceivedBack: boolean;
  patientDecreeReceivedBackDate?: Date;
  copyOfIdCardReceivedBack: boolean;
  copyOfIdCardReceivedBackDate?: Date;
  exemptionFromIDRequirements: boolean;
  exemptionFromIDRequirementsDate?: Date;
  careLevelNotificationReceivedBack: boolean;
  careLevelNotificationReceivedBackDate?: Date;
  disabilityCard: boolean;
  disabilityCardDate?: Date;
  marcurmarPassport: boolean;
  marcurmarPassportDate?: Date;
  implantationPassport: boolean;
  implantationPassportDate?: Date;
  pacemakerIDCard: boolean;
  pacemakerIDCardDate?: Date;
  roomKeyReturned: boolean;
  roomKeyReturnedDate?: Date;
}

export const CreateResidentChecklistSchema = yup
  .object({
    residentId: yup.string(),
  })
  .concat(ResidentChecklistSchema);

export interface ICreateResidentChecklist extends IResidentChecklist {
  residentId: string;
}

export const UpdateResidentChecklistSchema = yup
  .object({
    id: yup.string(),
  })
  .concat(ResidentChecklistSchema);

export interface IUpdateResidentChecklist extends IResidentChecklist {
  id: string;
}
